import React from 'react';
import { SSOLoginButton } from '../Auth';

const Landing: React.FC = () => {
  return (
    <div className="flex min-h-[calc(100vh-200px)] items-center justify-center">
      <div className="text-center max-w-md mx-auto px-4">
        <h1 className="text-2xl font-bold mb-4" style={{ color: 'var(--color-text-primary)' }}>
          Please sign in to continue
        </h1>
        <p className="mb-6 text-sm" style={{ color: 'var(--color-text-secondary)' }}>
          You need to be authenticated to access this page.
        </p>
        <SSOLoginButton variant="primary" size="md" />
      </div>
    </div>
  );
};

export default Landing;


